import React from 'react';
import { useAmplitude } from 'shared/hooks/use-amplitude';
import useDispensary from 'src/dispensary/hooks/use-dispensary';

import { Link } from 'components/core';

import { useDispensaryCategory } from 'src/hooks/use-dispensary-category';
import usePaths from 'hooks/use-paths';
import useProductQueryParams from 'hooks/use-product-query-params';
import { SubcategoryPillButton, SubcategoryPillContainer } from './styles';

export default function SubcategoryPill({ isSpecials, isSubcategory, label, value, selected }) {
  const category = useDispensaryCategory();
  const { href, route } = usePaths({ category, specials: isSpecials, subcategory: isSubcategory ? value : null });
  const { defaults, generateQueryParams } = useProductQueryParams();
  const amplitude = useAmplitude();
  const { dispensary } = useDispensary();

  const removeSubcategoryQueryParams = selected || !isSubcategory || !isSpecials;

  const newQuery = {
    ...generateQueryParams(`subcategories`, removeSubcategoryQueryParams ? defaults.subcategories : [value]),
  };
  delete newQuery.page;

  const trackEvent = () => {
    amplitude.log(`Subcategory Filter`, {
      description: `The user applies the subcategory filter option within a category page`,
      subcategorySelected: label,
      dispensaryId: dispensary?.id,
      dispensaryName: dispensary?.name,
    });
  };

  return (
    <SubcategoryPillContainer>
      <Link href={href} route={route} query={newQuery} scroll={false}>
        <SubcategoryPillButton selected={selected} onClick={trackEvent}>
          {label}
        </SubcategoryPillButton>
      </Link>
    </SubcategoryPillContainer>
  );
}
